var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "job-preview-right-column",
        _vm._g(
          {
            attrs: {
              "text-count-mode": _vm.textCountMode,
              "highlight-mode": _vm.highlightMode,
              "comment-highlights": _vm.commentHighlights,
              "text-counts": [
                _vm.getTextCount("求人名", _vm.title, _vm.targetIdMap.jobName),
              ],
            },
          },
          _vm.$listeners
        )
      ),
      _vm._v(" "),
      _c("div", { staticClass: "company-area" }, [
        _c("h1", {
          staticClass: "fs16 hd-type-02 company-title clearfix",
          attrs: { id: _vm.targetIdMap.jobName, "data-test": "title" },
          domProps: { textContent: _vm._s(_vm.title) },
        }),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "tags" },
          [
            _c("li", [
              _c("ul", { staticClass: "icon" }, [
                _c("li", { staticClass: "new" }, [
                  _c("img", {
                    attrs: {
                      src: _vm.userOfferImageUrlForPc + "/icon_company_new.png",
                      alt: "新着",
                      "data-test": "new",
                    },
                  }),
                ]),
                _vm._v(" "),
                _vm.isSimple && !_vm.isOriginalEntryForm
                  ? _c("li", { staticClass: "simple" }, [
                      _c("img", {
                        attrs: {
                          src:
                            _vm.userOfferImageUrlForPc +
                            "/icon_company_simple.png",
                          alt: "シンプル",
                          "data-test": "simple",
                        },
                      }),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "fs18" }, [_vm._v("｜")]),
            _vm._v(" "),
            _c("job-employment-status-pc", {
              attrs: { "employment-status": _vm.employmentStatus },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }